import { BroadcastedAlertNotification, BroadcastedNotification, NotificationDto, BaseNotification } from "@/js/interfaces/Components/alpinejs/NotificationMenu";
import notificationConfig from "@/js/config/notifications";
import { NOTIFICATION_INFINITE_DURATION, NotificationAlertType } from "@/js/interfaces/Components/alpinejs/NotificationAlert";
import { translate } from "@/app/support/utils";

/**
 * This method takes a NotificationDto and converts it into a NotificationMessage.
 */
export function getBaseNotificationFromDto(notification: NotificationDto): BaseNotification {
    return {
        id: notification.id,
        message: getNotificationMessageFromDto(notification),
        read_at: notification.read_at,
        created_at_for_humans: notification.created_at_for_humans,
    };
};

/**
 * This method takes broadcasted content and convert it into a DTO with more properties.
 */
export function getNotificationDtoFromBroadcast(broadcastedContent: BroadcastedNotification): NotificationDto {

    return {
        id: broadcastedContent.id,
        type: broadcastedContent.type,
        created_at_for_humans: 'Il y a 0 seconde',
        read_at: null,
        data: broadcastedContent,
    };
};

/**
 * This method takes broadcasted content and convert it into a NotificationMessage.
 */
export function getBaseNotificationFromBroadcast(broadcastedContent: BroadcastedNotification): BaseNotification {

    return getBaseNotificationFromDto(
        getNotificationDtoFromBroadcast(broadcastedContent),
    );
};

/**
 * This method retrieves an alert notification from broadcasted content.
 */
export function getAlertNotificationFromBroadcast(broadcastedContent: BroadcastedNotification): BroadcastedAlertNotification {
    const baseNotification = getBaseNotificationFromBroadcast(broadcastedContent);
    // Call the notification config alertType mapping
    const alertType: NotificationAlertType = Object.prototype.hasOwnProperty.call(notificationConfig.alertType, broadcastedContent.type)
        ? notificationConfig.alertType[broadcastedContent.type as keyof typeof notificationConfig.alertType]
        : notificationConfig.alertType['default'];

    return {
        id: baseNotification.id,
        title: translate('Your received a notification'),
        message: baseNotification.message,
        type: alertType,
        duration: NOTIFICATION_INFINITE_DURATION,
        created_at_for_humans: baseNotification.created_at_for_humans,
        read_at: baseNotification.read_at,
    };
}


/**
 * This method retrieves a message from a NotificationDto.
 */
function getNotificationMessageFromDto(notification: NotificationDto): string {
    return Object.prototype.hasOwnProperty.call(notificationConfig.message, notification.type)
        ? notificationConfig.message[notification.type as keyof typeof notificationConfig.message](notification.data as object)
        : notificationConfig.message['default']();
}

